import React, { FC, useEffect, useLayoutEffect, useState } from 'react';

import * as analytics from '@adsk/acs-web-analytics';
import { Theme } from '@adsk/alloy-react-box';

import { ANALYTICS_TYPES } from './analytics';
import { LaunchDarklyProvider } from './components/LaunchDarklyProvider';
import Router from './components/Router/Router';
import RemoteOverridesProvider from './providers/RemoteOverridesProvider';
import { RemotesProvider } from './providers/RemotesProvider';
import { initi18n } from './utils/i18n';
import { disposeMonitoringContext } from './utils/monitoring';

const App: FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      await initi18n();
      setLoading(false);
    };

    void init();
  }, []);

  useLayoutEffect(() => {
    analytics.waitForBaseProperties('license');

    analytics.track(ANALYTICS_TYPES.EXO_LOAD, {
      component_name: 'ExoSkeleton',
    });

    return () => {
      disposeMonitoringContext();
    };
  }, []);

  return (
    <Theme>
      <LaunchDarklyProvider>
        <RemoteOverridesProvider>
          <RemotesProvider>
            <div>{loading ? null : <Router />}</div>
          </RemotesProvider>
        </RemoteOverridesProvider>
      </LaunchDarklyProvider>
    </Theme>
  );
};

export default App;
